module.exports = __webpack_public_path__ + "static/media/6_My_Coupons.c7c2a4a5.png";